module.exports = __webpack_public_path__ + "static/media/bird4.35e884c0.svg";